import baseClasses from '@components/Themes/layout.module.scss'
import AuthService from '@services/auth.service'
import React, { FunctionComponent } from 'react'

import colors_red from '@components/Themes/colors_red.module.scss'
import { Icon as YesIcon } from '@iconify/react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import red from '@mui/material/colors/red'
import Container from '@mui/material/Container'
import Hidden from '@mui/material/Hidden'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Adminmodulescss from 'dist/css/Admin.module.scss'
import { NavLink } from 'react-router-dom'
import FileUpload from '../components/FileUpload/FileUpload'

const aptugotheme = createTheme({
  palette: {
    primary: red,
  },
})

const Register: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const initialDataUsers = {
    FirstName: '',
    LastName: '',
    Email: '',
    Password: '',
    ProfilePic: '',
    Role: '',
  }
  const [Usersdata, setUsersdata] = React.useState<any>(initialDataUsers)
  const handleUsersChange = (name: string) => (event: any) => {
    return new Promise((resolve, reject) => {
      const value = event?.target ? (event.target.files ? event.target.files[0] : event.currentTarget?.value || event.target.value) : event
      if (value !== Usersdata[name]) {
        setUsersdata((oldValues) => {
          return {
            ...oldValues,
            [name]: value,
          }
        })
      }
      resolve(value)
    })
  }
  const [currentUser, setcurrentUser] = React.useState<any>({})
  const [profileMenuAnchor, setprofileMenuAnchor] = React.useState<any>(null)
  const [menuAnchorUsers, setmenuAnchorUsers] = React.useState<any>(null)
  const [menuAnchorVacancy, setmenuAnchorVacancy] = React.useState<any>(null)
  const [menuAnchorServices, setmenuAnchorServices] = React.useState<any>(null)
  const [menuAnchorAboutAs, setmenuAnchorAboutAs] = React.useState<any>(null)
  const [menuAnchorClients, setmenuAnchorClients] = React.useState<any>(null)
  const [menuAnchorBanners, setmenuAnchorBanners] = React.useState<any>(null)
  const [isMenuOpen, setisMenuOpen] = React.useState<any>(false)
  const toggleMenu = (e) => {
    e.preventDefault()
    setisMenuOpen((prevState) => !prevState)
  }
  const theme = { ...colors_red, ...baseClasses, ...Adminmodulescss }
  const [registerError, setregisterError] = React.useState<any>(null)
  const [usersData, setusersData] = React.useState<any>({
    errField: null,
    errMessage: null,
  })

  // Theme selection

  React.useEffect(() => {
    AuthService.getCurrentUser().then((currentUser) => {
      setcurrentUser(currentUser)
    })
  }, [])

  const handleRegister = () => {
    const data = { ...Usersdata, Role: 'User' }

    AuthService.register(data)
      .then((_result) => {
        navigation.push('/')
      })
      .catch((error) => {
        setregisterError(error.response.data.message)
      })
  }
  return (
    <React.Fragment>
      <ThemeProvider theme={aptugotheme}>
        <div className={theme.registerBody}>
          {currentUser && (
            <React.Fragment>
              <div data-title="Container" className={theme.container}>
                <NavLink to="/admin">
                  <div data-title="divLogo" className={theme.divLogo}>
                    <picture>
                      <img src="/img/Home_topPageTitulo.svg" alt="/img/Home_topPageTitulo.svg" />
                    </picture>
                  </div>
                </NavLink>

                <Hidden mdDown>
                  <div data-title="Buttons" className={theme.topbarButtons} onClick={(e) => toggleMenu}>
                    <IconButton
                      onClick={(event) => {
                        setmenuAnchorBanners(event.currentTarget)
                      }}
                      className={theme.link}
                    >
                      <Typography variant="">Banners</Typography>
                    </IconButton>

                    <IconButton
                      onClick={(event) => {
                        setmenuAnchorClients(event.currentTarget)
                      }}
                      className={theme.link}
                    >
                      <Typography variant="">Home</Typography>
                    </IconButton>

                    <IconButton
                      onClick={(event) => {
                        setmenuAnchorAboutAs(event.currentTarget)
                      }}
                      className={theme.link}
                    >
                      <Typography variant="">Nosotros</Typography>
                    </IconButton>

                    <IconButton
                      onClick={(event) => {
                        setmenuAnchorVacancy(event.currentTarget)
                      }}
                      className={theme.link}
                    >
                      <Typography variant="">Prensa</Typography>
                    </IconButton>

                    <IconButton
                      onClick={(event) => {
                        setmenuAnchorUsers(event.currentTarget)
                      }}
                      className={theme.link}
                    >
                      <Typography variant="">Administradores</Typography>
                    </IconButton>

                    <IconButton
                      onClick={(event) => {
                        setprofileMenuAnchor(event.currentTarget)
                      }}
                      className={theme.profilePicture}
                    >
                      <div data-title="div Image" className={theme.divImage}>
                        <picture>
                          <img src="/img/favicon.png" alt="/img/favicon.png" />
                        </picture>
                      </div>
                    </IconButton>
                  </div>
                </Hidden>

                <Hidden>
                  <div data-title="Hamburger" className={theme.hamburgerMenu} onClick={(e) => toggleMenu(e)}>
                    {isMenuOpen && (
                      <React.Fragment>
                        <YesIcon icon="material-symbols:close-rounded" />
                      </React.Fragment>
                    )}

                    {!isMenuOpen && (
                      <React.Fragment>
                        <YesIcon icon="material-symbols:menu" />
                      </React.Fragment>
                    )}

                    {isMenuOpen && (
                      <React.Fragment>
                        <div data-title="fullscreenMenu" className={theme.fullscreenMenu}>
                          <div data-title="Buttons" className={theme.topbarButtons}>
                            <NavLink exact to="/admin/Users" key="K2bsyl8T">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>Users</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/CarouselTopPages" key="IE49CwTW">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CarouselTopPages</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/TopPagesAboutUs" key="FPLucGZ6">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>TopPagesAboutUs</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/TopPagesJoinUs" key="9bmi85Pq">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>TopPagesJoinUs</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/TopPagesPress" key="KmNm5zDu">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>TopPagesPress</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/CardsDestinos" key="izuvn2UD">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CardsDestinos</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/CardsPartners" key="PQdu70lU">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CardsPartners</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/CardsTourDesks" key="SyAANG8v">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CardsTourDesks</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/CardsInstagram" key="Bk6f9gV4">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CardsInstagram</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/Contacts" key="Rs8eU9OI">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>Contacts</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/SeccionSocios" key="ILo0AULy">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>SeccionSocios</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/SeccionITs" key="e5bbXf8f">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>SeccionITs</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/SeccionTurismos" key="ByAuf6Zl">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>SeccionTurismos</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/SeccionMarketings" key="Vqc2ynKB">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>SeccionMarketings</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/SeccionFinanzas" key="B4qTZsSv">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>SeccionFinanzas</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/admin/CardsPress" key="d2CEm0eX">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>CardsPress</ListItemText>
                              </ListItem>
                            </NavLink>

                            <NavLink exact to="/register" key="mZwTTATH">
                              <ListItem button className={classes.itemLink}>
                                <ListItemText>Register</ListItemText>
                              </ListItem>
                            </NavLink>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </Hidden>
              </div>

              <Menu
                className={theme.dropdownMenu}
                anchorEl={menuAnchorBanners}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(menuAnchorBanners)}
                onClose={(params) => {
                  setmenuAnchorBanners(null)
                }}
              >
                <MenuList>
                  <NavLink to="/CarouselTopPages">
                    <Typography variant="">Home</Typography>
                  </NavLink>

                  <NavLink to="/TopPagesAboutUs">
                    <Typography variant="">Nosotros</Typography>
                  </NavLink>

                  <NavLink to="/TopPagesJoinUs">
                    <Typography variant="">Sé Parte</Typography>
                  </NavLink>

                  <NavLink to="/TopPagesPress">
                    <Typography variant="">Prensa</Typography>
                  </NavLink>
                </MenuList>
              </Menu>

              <Menu
                className={theme.dropdownMenu}
                anchorEl={menuAnchorClients}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(menuAnchorClients)}
                onClose={(params) => {
                  setmenuAnchorClients(null)
                }}
              >
                <MenuList>
                  <NavLink to="/admin/CardsDestinos">
                    <Typography variant="">Cards Destinos</Typography>
                  </NavLink>

                  <NavLink to="/CardsPartners">
                    <Typography variant="">Cards Partners</Typography>
                  </NavLink>

                  <NavLink to="/admin/CardsTourDesks">
                    <Typography variant="">Cards TourDesk</Typography>
                  </NavLink>

                  <NavLink to="/CardsInstagram">
                    <Typography variant="">Cards Instagram</Typography>
                  </NavLink>
                </MenuList>
              </Menu>

              <Menu
                className={theme.dropdownMenu}
                anchorEl={menuAnchorAboutAs}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(menuAnchorAboutAs)}
                onClose={(params) => {
                  setmenuAnchorAboutAs(null)
                }}
              >
                <MenuList>
                  <NavLink to="/admin/SeccionSocios">
                    <Typography variant="">Seccion Socios</Typography>
                  </NavLink>

                  <NavLink to="/admin/SeccionITs">
                    <Typography variant="">Seccion IT</Typography>
                  </NavLink>

                  <NavLink to="/admin/SeccionTurismos">
                    <Typography variant="">Seccion Turismos</Typography>
                  </NavLink>

                  <NavLink to="/admin/SeccionMarketings">
                    <Typography variant="">Seccion Marketings</Typography>
                  </NavLink>

                  <NavLink to="/admin/SeccionFinanzas">
                    <Typography variant="">Seccion Finanzas</Typography>
                  </NavLink>
                </MenuList>
              </Menu>

              <Menu
                className={theme.dropdownMenu}
                anchorEl={menuAnchorVacancy}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(menuAnchorVacancy)}
                onClose={(params) => {
                  setmenuAnchorVacancy(null)
                }}
              >
                <MenuList>
                  <NavLink to="/admin/CardsPress">
                    <Typography variant="">Cards Prensa</Typography>
                  </NavLink>
                </MenuList>
              </Menu>

              <Menu
                className={theme.dropdownMenu}
                anchorEl={menuAnchorUsers}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(menuAnchorUsers)}
                onClose={(params) => {
                  setmenuAnchorUsers(null)
                }}
              >
                <MenuList>
                  <NavLink to="/admin/Users">
                    <Typography variant="">Administradores</Typography>
                  </NavLink>
                </MenuList>
              </Menu>

              <Menu
                className={theme.menuProfile}
                anchorEl={profileMenuAnchor}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(profileMenuAnchor)}
                onClose={(params) => {
                  setprofileMenuAnchor(null)
                }}
              >
                <div data-title="div" className={theme.menuProfileDetails}>
                  {currentUser.FirstName} {currentUser.LastName}
                </div>

                <div data-title="Divider" className={theme.divider}></div>

                <MenuItem
                  onClick={(params) => {
                    AuthService.logout()
                    props.history.push('/')
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}

          <Container className={theme.loginPage} maxWidth="md">
            <div data-title="Login Area" className={theme.containerLogin}>
              <span className={theme.right}>Have an account?</span>

              <a href="/login">
                <span className={theme.textRegister}>Login!</span>
              </a>
            </div>

            <div data-title="Register Box" className={theme.loginBox}>
              <div data-title="Heading" className={theme.headingLogin}>
                <div data-title="div">
                  <span className={theme.textSignIn}>Register</span>
                </div>

                <div data-title="div">
                  <span className={theme.textEnterBelow}>Enter your details below.</span>
                </div>
              </div>

              {registerError && (
                <React.Fragment>
                  <Alert variant="standard" severity="error">
                    {registerError}
                  </Alert>
                </React.Fragment>
              )}

              <TextField
                margin="normal"
                size="medium"
                label="FirstName"
                type="text"
                fullWidth
                className={'field_FirstName'}
                variant="outlined"
                value={Usersdata.FirstName || ''}
                onChange={handleUsersChange('FirstName')}
                error={Usersdata?.errField === 'FirstName'}
                helperText={Usersdata?.errField === 'FirstName' && Usersdata.errMessage}
              />

              <TextField
                margin="normal"
                size="medium"
                label="LastName"
                type="text"
                fullWidth
                className={'field_LastName'}
                variant="outlined"
                value={Usersdata.LastName || ''}
                onChange={handleUsersChange('LastName')}
                error={Usersdata?.errField === 'LastName'}
                helperText={Usersdata?.errField === 'LastName' && Usersdata.errMessage}
              />

              <TextField
                margin="normal"
                size="medium"
                label="Email"
                type="text"
                fullWidth
                className={'field_Email'}
                variant="outlined"
                value={Usersdata.Email || ''}
                onChange={handleUsersChange('Email')}
                error={Usersdata?.errField === 'Email'}
                helperText={Usersdata?.errField === 'Email' && Usersdata.errMessage}
              />

              <TextField
                margin="normal"
                size="medium"
                label="Password"
                type="password"
                fullWidth
                variant="outlined"
                value={Usersdata.Password}
                onChange={handleUsersChange('Password')}
                error={usersData?.errField === 'Password'}
                helperText={usersData?.errField === 'Password' && usersData.errMessage}
              />

              <FileUpload label="Profile Picture" value={Usersdata.ProfilePic} onChange={handleUsersChange('ProfilePic')} variant="outlined" />

              <Button variant="contained" color="primary" onClickCapture={handleRegister} className={theme.buttonLogin}>
                Register
              </Button>
            </div>
          </Container>
        </div>
      </ThemeProvider>
    </React.Fragment>
  )
}

export default Register
